export const displayCenter = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
